<div class="m-2 container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-10 col-xl-8">
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        <p-card class="p-4">
          <ng-template #header>
            <div class="flex align-items-center justify-content-between">
              <h2 class="m-0 text-2xl font-bold">{{ pageTitle }}</h2>
            </div>
          </ng-template>
          <!-- Informações Básicas -->
          <div class="mb-4">
            <h3 class="text-lg font-semibold mb-3 text-primary">Informações Básicas</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="field">
                <label for="name" class="block text-sm font-medium mb-2">
                  Nome <span class="text-red-500">*</span>
                </label>
                <input 
                  type="text" 
                  pInputText 
                  id="name"
                  formControlName="name"
                  placeholder="Ex: João Silva"
                  class="w-full"
                  [class.p-invalid]="userForm.get('name')?.invalid && userForm.get('name')?.touched" />
                <small 
                  *ngIf="getFieldError('name')" 
                  class="p-error block mt-1">
                  {{ getFieldError('name') }}
                </small>
              </div>
              
              <div class="field">
                <label for="email" class="block text-sm font-medium mb-2">
                  Email <span class="text-red-500">*</span>
                </label>
                <input 
                  type="email" 
                  pInputText 
                  id="email"
                  formControlName="email"
                  placeholder="Ex: joao@email.com"
                  class="w-full"
                  [class.p-invalid]="userForm.get('email')?.invalid && userForm.get('email')?.touched" />
                <small 
                  *ngIf="getFieldError('email')" 
                  class="p-error block mt-1">
                  {{ getFieldError('email') }}
                </small>
              </div>
              
              <div class="field">
                <label for="phone" class="block text-sm font-medium mb-2">
                  Telefone
                </label>
                <input 
                  type="tel" 
                  pInputText 
                  id="phone"
                  formControlName="phone"
                  placeholder="Ex: (11) 99999-9999"
                  class="w-full"
                  [class.p-invalid]="userForm.get('phone')?.invalid && userForm.get('phone')?.touched" />
                <small 
                  *ngIf="getFieldError('phone')" 
                  class="p-error block mt-1">
                  {{ getFieldError('phone') }}
                </small>
              </div>
            </div>
          </div>

          <!-- Endereços -->
          <div class="mb-4">
            <div class="flex align-items-center justify-content-between mb-3">
              <h3 class="text-lg font-semibold text-primary m-0">Endereços</h3>
              <p-button 
                label="Adicionar Endereço" 
                icon="pi pi-plus" 
                severity="secondary"
                size="small"
                (onClick)="addAddress()"
                [disabled]="isLoading" />
            </div>
            
            <div formArrayName="addresses">
              <div 
                *ngFor="let address of addressesFormArray.controls; let i = index"
                [formGroupName]="i"
                class="mb-3 border-round border-1 border-200 overflow-hidden">
                <!-- Cabeçalho do Endereço (Clicável) -->
                <div 
                  class="flex align-items-center justify-content-between p-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors"
                  (click)="toggleAddress(i)">
                  <div class="flex align-items-center gap-2">
                    <i 
                      [class]="isAddressExpanded(i) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                      class="text-sm"></i>
                    <h4 class="text-md font-semibold m-0">Endereço {{ i + 1 }}</h4>
                    <span 
                      *ngIf="addressesFormArray.at(i).get('addressName')?.value"
                      class="text-sm text-gray-600">
                      - {{ addressesFormArray.at(i).get('addressName')?.value }}
                    </span>
                  </div>
                  <div class="flex align-items-center gap-2" (click)="$event.stopPropagation()">
                    <p-button 
                      label="Remover" 
                      icon="pi pi-trash" 
                      severity="danger"
                      size="small"
                      (onClick)="removeAddress(i)"
                      [disabled]="addressesFormArray.length <= 1"
                      [text]="true" />
                  </div>
                </div>
                
                <!-- Conteúdo do Endereço (Expansível) -->
                <div 
                  *ngIf="isAddressExpanded(i)"
                  class="p-3 bg-white">
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div class="field">
                    <label [for]="'zipCode_' + i" class="block text-sm font-medium mb-2">
                      CEP <span class="text-red-500">*</span>
                    </label>
                    <input 
                      type="text" 
                      pInputText 
                      [id]="'zipCode_' + i"
                      formControlName="zipCode"
                      placeholder="Ex: 12345-678"
                      class="w-full"
                      [class.p-invalid]="addressesFormArray.at(i).get('zipCode')?.invalid && addressesFormArray.at(i).get('zipCode')?.touched" />
                    <small 
                      *ngIf="getFieldError('zipCode', i)" 
                      class="p-error block mt-1">
                      {{ getFieldError('zipCode', i) }}
                    </small>
                  </div>
                  
                  <div class="field">
                    <label [for]="'addressName_' + i" class="block text-sm font-medium mb-2">
                      Rua/Avenida <span class="text-red-500">*</span>
                    </label>
                    <input 
                      type="text" 
                      pInputText 
                      [id]="'addressName_' + i"
                      formControlName="addressName"
                      placeholder="Ex: Rua das Flores"
                      class="w-full"
                      [class.p-invalid]="addressesFormArray.at(i).get('addressName')?.invalid && addressesFormArray.at(i).get('addressName')?.touched" />
                    <small 
                      *ngIf="getFieldError('addressName', i)" 
                      class="p-error block mt-1">
                      {{ getFieldError('addressName', i) }}
                    </small>
                  </div>
                  
                  <div class="field">
                    <label [for]="'number_' + i" class="block text-sm font-medium mb-2">
                      Número
                    </label>
                    <input 
                      type="text" 
                      pInputText 
                      [id]="'number_' + i"
                      formControlName="number"
                      placeholder="Ex: 123"
                      class="w-full"
                      [class.p-invalid]="addressesFormArray.at(i).get('number')?.invalid && addressesFormArray.at(i).get('number')?.touched" />
                    <small 
                      *ngIf="getFieldError('number', i)" 
                      class="p-error block mt-1">
                      {{ getFieldError('number', i) }}
                    </small>
                  </div>
                  
                  <div class="field">
                    <label [for]="'district_' + i" class="block text-sm font-medium mb-2">
                      Bairro <span class="text-red-500">*</span>
                    </label>
                    <input 
                      type="text" 
                      pInputText 
                      [id]="'district_' + i"
                      formControlName="district"
                      placeholder="Ex: Centro"
                      class="w-full"
                      [class.p-invalid]="addressesFormArray.at(i).get('district')?.invalid && addressesFormArray.at(i).get('district')?.touched" />
                    <small 
                      *ngIf="getFieldError('district', i)" 
                      class="p-error block mt-1">
                      {{ getFieldError('district', i) }}
                    </small>
                  </div>
                  
                  <div class="field md:col-span-2">
                    <label [for]="'cityId_' + i" class="block text-sm font-medium mb-2">
                      Cidade <span class="text-red-500">*</span>
                    </label>
                    <p-select
                      [id]="'cityId_' + i"
                      formControlName="cityId"
                      [options]="cities"
                      optionLabel="name"
                      optionValue="id"
                      placeholder="Selecione uma cidade"
                      [showClear]="true"
                      class="w-full"
                      [class.p-invalid]="addressesFormArray.at(i).get('cityId')?.invalid && addressesFormArray.at(i).get('cityId')?.touched" />
                    <small 
                      *ngIf="getFieldError('cityId', i)" 
                      class="p-error block mt-1">
                      {{ getFieldError('cityId', i) }}
                    </small>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Status do Cliente -->
          <div class="mb-4">
            <h3 class="text-lg font-semibold mb-3 text-primary">Status do Cliente</h3>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div class="field">
                <div class="flex align-items-center">
                  <p-checkbox 
                    formControlName="isActive"
                    [binary]="true"
                    inputId="isActive"
                    class="mr-2" />
                  <label for="isActive" class="text-sm font-medium cursor-pointer">
                    Cliente Ativo
                  </label>
                </div>
              </div>
              
              <div class="field">
                <div class="flex align-items-center">
                  <p-checkbox 
                    formControlName="isBlocked"
                    [binary]="true"
                    inputId="isBlocked"
                    class="mr-2" />
                  <label for="isBlocked" class="text-sm font-medium cursor-pointer">
                    Cliente Bloqueado
                  </label>
                </div>
              </div>

              <div class="field">
                <div class="flex align-items-center">
                  <p-checkbox 
                    formControlName="canRequestRide"
                    [binary]="true"
                    inputId="canRequestRide"
                    class="mr-2" />
                  <label for="canRequestRide" class="text-sm font-medium cursor-pointer">
                    Pode Solicitar Corrida
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- Mensagem de Erro -->
          <div *ngIf="errorMessage" class="mb-4">
            <p-message 
              severity="error" 
              [text]="errorMessage" 
              [closable]="false" />
          </div>
        </p-card>

        <!-- Botões de Ação -->
        <div class="bg-white rounded-lg shadow-1 p-4 mt-3">
          <div class="flex justify-content-end gap-2">
            <p-button 
              label="Cancelar" 
              severity="secondary" 
              (onClick)="onCancel()"
              [disabled]="isLoading"
              icon="pi pi-times" />
            
            <p-button 
              [label]="submitButtonText"
              severity="primary"
              type="submit"
              [disabled]="isLoading || userForm.invalid || (isEditMode)"
              [loading]="isLoading"
              icon="pi pi-check" />
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
